module.exports = __webpack_public_path__ + "static/media/profileimageMobile.28ed7dac.jpg";